import usePermissions from 'src/configs/auth';
import { ROUTES } from 'src/constants/routes';

const useDefaultPage = () => {
  const { hasAccountPermission } = usePermissions();

  const getDefaultPage = (account?: Account) => {
    if (hasAccountPermission('deals', account)) {
      return ROUTES.DEALS;
    } else {
      return ROUTES.INVENTORY;
    }
  };

  return {
    getDefaultPage,
  };
};

export default useDefaultPage;
